var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from "styled-components";
import Select from "react-select";
import { colorTheme, textTheme } from "../themes";
// styling for the react-select library
export var customStyles = {
    control: function (styles) { return (__assign(__assign({}, styles), { height: 42, width: 184, paddingLeft: 5, borderColor: "rgba(195, 203, 205, 0.35)", boxShadow: "none", "&:hover": {
            cursor: "pointer",
        } })); },
    indicatorSeparator: function () { return ({
        color: colorTheme.white,
    }); },
    dropdownIndicator: function () { return ({
        color: colorTheme.grayDark,
        paddingRight: 15,
        paddingTop: 5,
    }); },
    menu: function (styles) { return (__assign(__assign({}, styles), { backgroundColor: colorTheme.white, position: "absolute", top: 0, margin: 0, paddingBottom: 5, paddingTop: 10, borderRadius: 0 })); },
    option: function (styles) { return (__assign(__assign({}, styles), { height: 42, width: 184, paddingLeft: 20, backgroundColor: colorTheme.white, color: colorTheme.black, "&:hover": {
            cursor: "pointer",
        } })); },
};
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n"])));
export var CustomContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: 20px;\n"])));
export var DateSelector = styled(Select)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  width: 184px;\n  height: 42px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);\n  :focus {\n    outline: 0 !important;\n  }\n"], ["\n  ", ";\n  width: 184px;\n  height: 42px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);\n  :focus {\n    outline: 0 !important;\n  }\n"])), textTheme.body2);
export var DatePickerContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  float: left;\n"], ["\n  position: relative;\n  float: left;\n"])));
export var Icon = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  margin-left: 18px;\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  margin-left: 18px;\n"])));
export var To = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0px 10px;\n"], ["\n  margin: 0px 10px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=PageDateSelector.styles.js.map